import { render, staticRenderFns } from "./TimberWoodInfoForm.vue?vue&type=template&id=48f7bca0&scoped=true&"
import script from "./TimberWoodInfoForm.vue?vue&type=script&lang=js&"
export * from "./TimberWoodInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f7bca0",
  null
  
)

export default component.exports